import React, {Component} from 'react';
import styles from "./Esito.module.css";
import Calendar from "../../../../components/calendar/Calendar";
import {states} from '../../States/States';
import Utils from "../../../../utils/Utils";
import OggettiUtili from "../../../../utils/OggettiUtili.json";
import SegnalazioniService from "../../../../services/SegnalazioniServices";
import {withTranslation} from "react-i18next";
import MalattieService from "../../../../services/MalattieService"
import toasterConfig from "../../../../config/toasterConfig";
import history from "../../../../utils/History";
import ToasterSingleton from "../../../../singleton/ToasterSingleton";
import Select from "../../../../components/select/Select";
import $ from 'jquery'
import ButtonRow from "../../../../components/ButtonRow/ButtonRow";
import SessioneUtente from "../../../../sessionManager/SessioneUtente";
import Ruoli from "../../../../utils/Ruoli";
import Input from "../../../../components/textbox/Input";
import Modale from "../../../../components/modale/Modale";

const esameAutopticoMap = require("../../../../dizionari/mappaEsameAutoptico");


class Esito extends Component {

    state = {
        esito: {
            esito: this.props.malattiePremal.includes(this.props.segnalazioneCopia.malattia)? "148*" : "",
            esame: "",
            dataEsito: this.props.malattiePremal.includes(this.props.segnalazioneCopia.malattia)? Utils.formatDateISO(this.props.segnalazioneCopia.timestampCompilazione) : "",
            dataDecesso: "",
            dataEsame: ""
        },
        campoRequired: false,
        listaEsiti: [],
        mostraPopUpIniziale:true,
        malattiePremal: OggettiUtili.malattiePremalCodici,
    };

    constructor(props) {
        super(props);
        this._validate = this._validate.bind(this);
        this._back = this._back.bind(this);
        this.handleChangeEsito = this.handleChangeEsito.bind(this);
        this.handleChangeEsame = this.handleChangeEsame.bind(this);
        this.riceviValore = this.riceviValore.bind(this);
        this.aggiungiToaster = this.aggiungiToaster.bind(this)
        this.disabledDate = this.disabledDate.bind(this)
        this.nextStep = this.nextStep.bind(this)
        this.controlloDatiToaster = this.controlloDatiToaster.bind(this)
        this.closePopup=this.closePopup.bind(this)
    }

    componentWillUnmount() {
        ToasterSingleton.instance().cancellazioneSottoscrizione()
        ToasterSingleton.instance().pulisci()
    }

    componentDidMount() {
        this.setState({mostraPopUpIniziale:!this.props.segnalazioneCopia.stepConfermati.esitoConfermato})
        ToasterSingleton.instance().sottoscrizione(this)

        MalattieService.getEsiti(this.props.datiPaziente.malattia).then((data) => {
            let res = Utils.mapToArray(data.data);
            this.setState({listaEsiti: res})
        }).catch(() => {
            console.log("errore chiamata info cliniche")
        });
        if (this.props.segnalazioneCopia.esito) {
            let esito = this.state.esito
            let campoRequired
            esito.esito = this.props.segnalazioneCopia.esito.esito ? this.props.segnalazioneCopia.esito.esito : ""
            esito.esame = this.props.segnalazioneCopia.esito.esame ? this.props.segnalazioneCopia.esito.esame : ""
            esito.dataEsito = this.props.segnalazioneCopia.esito.dataEsito ? Utils.formatDateISO(this.props.segnalazioneCopia.esito.dataEsito) : ""
            esito.dataDecesso = this.props.segnalazioneCopia.esito.dataDecesso ?
                Utils.formatDateISO(this.props.segnalazioneCopia.esito.dataDecesso) : ""
            esito.dataEsame =
                this.props.segnalazioneCopia.esito.dataEsame ? Utils.formatDateISO(this.props.segnalazioneCopia.esito.dataEsame) : ""

            this.setState({
                esito: esito,
                campoRequired: campoRequired
            })
        }

        this.disabledDate()
        $('#noteMigrazione :input').fadeTo("opacity", 1);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        this.disabledDate()
    }

    disabledDate() {
        let esito = this.state.esito
        if (esito.esito !== "23") {
            $(document).ready(function () {
                $("#dataDecesso").datepicker('disable');
                $("#dataEsame").datepicker('disable');
            })
        } else {
            $(document).ready(function () {
                $("#dataDecesso").datepicker('enable');
                $("#dataEsame").datepicker('enable');
            })
        }
        $(document).ready(function () {
            $("#dataEsito").datepicker('enable');
        })

        if (esito.esame !== "1") {
            $(document).ready(function () {
                $("#dataEsame").datepicker('disable');
            })
        } else {
            $(document).ready(function () {
                $("#dataEsame").datepicker('enable');
            })
        }
        if ((this.props.segnalazione && this.props.segnalazione.migrazione) || SessioneUtente.getInstance().ruoliUtente === Ruoli.Operatore_Laboratorio.descrizione || (this.props.segnalazioneCopia && (this.props.segnalazioneCopia.statoSegnalazione === OggettiUtili.statoSegnalazioneByLabel.Archiviato.codice ||
            this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice))) {
            $(document).ready(function () {
                $("#dataDecesso").datepicker('disable');
                $("#dataEsito").datepicker('disable');
                $("#dataEsame").datepicker('disable');
            })
        } else {
            $(document).ready(function () {
                $("#dataDecesso").datepicker('enable');
                $("#dataEsito").datepicker('enable');
                $("#dataEsame").datepicker('enable');
            })
        }
    }

    handleChangeEsito(event) {

        let newEsito = this.state.esito
        let campoRequired = true
        newEsito.esito = event.target.value

        if (event.target.value !== "23") {
            campoRequired = false
            newEsito.dataDecesso = "";
            newEsito.dataEsame = ""
            newEsito.esame = ""
        }
        this.setState({
            campoRequired: campoRequired,
            esito: newEsito,
        });
    }

    handleChangeEsame(event) {

        let newEsame = event.target.value
        let newEsito = this.state.esito
        newEsito.esame = newEsame;

        if (newEsito.esame !== "1") {
            newEsito.dataEsame = ""
        }

        this.setState({
            esito: newEsito
        });
    }

    controlloDatiToaster(tipo){
        let textList = []
        let newEsito = this.state.esito

        if (!newEsito.esito) textList.push("Campo \"Esito\" mancante")
        if (!newEsito.dataEsito) textList.push("Campo \"Data Esito\" mancante")
        if (newEsito.dataEsito && (Utils.isDateInValid(Utils.transformDateForBackend(newEsito.dataEsito), "-"))) textList.push("Campo \"Data Esito\" errato")
        if (newEsito.esito && newEsito.esito === "23" && !newEsito.esame) textList.push("Campo \"Effettuazione esame autoptico\" mancante")
        if (newEsito.esame === "1" && !newEsito.dataEsame) textList.push("Campo \"Data esame autoptico\" mancante")
        if (newEsito.dataEsame && (Utils.isDateInValid(Utils.transformDateForBackend(newEsito.dataEsame), "-"))) textList.push("Campo \"Data esame autoptico\" errato")

        if(textList.length > 0 && tipo === "1") return this.aggiungiToaster(textList, true)
        else if(textList.length > 0 && tipo === "2" &&
            this.props.segnalazioneCopia.stepConfermati &&
            this.props.segnalazioneCopia.esito &&
            this.props.segnalazioneCopia.stepConfermati.esitoConfermato) return this.aggiungiToaster(textList, true)
        else {
            if(tipo === "1"){
                if((this.props.segnalazione && this.props.segnalazione.migrazione) || SessioneUtente.getInstance().ruoliUtente === Ruoli.Operatore_Laboratorio.descrizione || (this.props.segnalazioneCopia && (this.props.segnalazioneCopia.statoSegnalazione === OggettiUtili.statoSegnalazioneByLabel.Archiviato.codice ||
                    this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice))){
                    this.nextStep(this.props.segnalazioneCopia, this.props.segnalazioneCopia)
                }
                else{
                    this._validate(0)
                }
            }
            else if(tipo === "2"){
                this._validate(1)
            }
        }

    }

    riceviValore(field) {

        let newEsito = this.state.esito

        if (field.currentTarget) {
            if (field.currentTarget.id === "dataEsito") {
                newEsito.dataEsito = field.currentTarget.value;
            } else if (field.currentTarget.id === "dataEsame") {
                newEsito.dataEsame = field.currentTarget.value;
            } else if (field.currentTarget.id === "dataDecesso") {
                newEsito.dataDecesso = field.currentTarget.value;
            }
        }

        this.setState({
            esito: newEsito,
        })
    }

    aggiungiToaster(text, textList) {

        ToasterSingleton.instance().aggiuntaToaster({
            type: toasterConfig.types.confirm,
            text: text,
            timestamp: Date.now(),
            textList: textList
        })

    }

    callToPutSegnalazione() {
        let jsonInsert = this.props.segnalazione
        SegnalazioniService.putModificaSegnalazione(jsonInsert, this.props.segnalazione.idSegnalazione, this.props.updateWizardState,
            this.props.segnalazione, this.props.showSpinner)
    }

    nextStep(segnalazione, segnalazioneCopia) {
        let path = "/wizardSegnalazione";
        let pathHome = "/ricercaSegnalazioni"
        history.push({
            pathname: this.props.infoMalattia && this.props.listaSezioni.length > 0 ? path : pathHome,
            state: {
                currentState: this.props.infoMalattia ? states.DATI_SPECIFICI : states.HOME,
                segnalazione: segnalazione,
                segnalazioneCopia: segnalazioneCopia,
                datiCompletiECorretti: Utils.getCompletezzaStep(segnalazione)
            }
        })
    }


    callToConfermaEsito() {
        let jsonEsito = {esito: this.props.segnalazione.esito};
        let path = ""

        if (this.props.listaSezioni.length === 0) {
            jsonEsito.statoSegnalazione = "03";
            path = "/ricercaSegnalazioni"
        }

        SegnalazioniService.postConfermaEsito(this.props.segnalazione.idSegnalazione, jsonEsito)
            .then((data) => {
                this.props.showSpinner(false);
                if (data && data.status === 200) {
                    let segnalazioneSalvata = this.props.segnalazione;
                    segnalazioneSalvata["stepConfermati"] = data.data.stepConfermati;
                    {
                        path ?
                            history.push({
                                pathname: path,
                                state: {
                                    currentState: states.HOME,
                                }
                            }) :
                            this.nextStep(segnalazioneSalvata, this.props.segnalazioneCopia);
                    }
                }
            })
            .catch(() => {
                this.props.showSpinner(false);
            })


    }

    _validate(clickSalvaOConferma) {

        let {t} = this.props;

        if (this.state.esito.esito !== "23" && this.state.esito.esame !== "") {    //esito != da decesso ma esame autoptico valorizzato
            let newMessaggio = t("Messages.ERR_01_01_0E_0G")
            return (
                this.aggiungiToaster(newMessaggio))
        }

        if (this.state.esito.dataEsito !== "" && (Utils.isDateInValid(Utils.transformDateForBackend(this.state.esito.dataEsito), "-"))) {

            let newMessaggio = Utils.replaceContentString(t("Messages.ERR_01_01_0B_0A"), "<nome campo>", t("Esito.dataEsito"))
            return (
                this.aggiungiToaster(newMessaggio)
            )

        }

        if (this.state.esito.dataDecesso !== "" && (Utils.isDateInValid(Utils.transformDateForBackend(this.state.esito.dataDecesso), "-"))) {

            let newMessaggio = Utils.replaceContentString(t("Messages.ERR_01_01_0B_0A"), "<nome campo>", t("Esito.dataDecesso"))
            return (
                this.aggiungiToaster(newMessaggio)
            )

        }

        if (this.state.esito.dataEsame !== "" && (Utils.isDateInValid(Utils.transformDateForBackend(this.state.esito.dataEsame), "-"))) {

            let newMessaggio = Utils.replaceContentString(t("Messages.ERR_01_01_0B_0A"), "<nome campo>", t("Esito.dataEsameAutoptico"))
            return (
                this.aggiungiToaster(newMessaggio)
            )

        }

        if (this.state.esito.dataEsito !== "") {
            let validateDataEsito = Utils.checkDateInterval(this.state.esito.dataEsito, "31/12/1899");
            let checkTodayDataEsito = Utils.checkDateLowerToday(this.state.esito.dataEsito);
            if (validateDataEsito) {
                return (
                    this.aggiungiToaster(["Messages.ERR_01_01_0E_0B"])
                )
            } else if (checkTodayDataEsito) {
                return (
                    this.aggiungiToaster(["Messages.ERR_01_01_0E_0C"]))

            } else if (this.state.esito.dataEsito === "" || (Utils.isDateInValid(Utils.transformDateForBackend(this.state.esito.dataEsito), "-"))) {

                let newMessaggio = Utils.replaceContentString(t("Messages.ERR_01_01_0B_0A"), "nome campo", t("Esito.dataEsito"))
                return (
                    this.aggiungiToaster(newMessaggio)
                )

            }
        }

        if (this.state.esito.dataDecesso !== "") {
            let validateDataDecesso = Utils.checkDateInterval(this.state.esito.dataDecesso, "31/12/1899");
            let checkTodayDataDecesso = Utils.checkDateLowerToday(this.state.esito.dataDecesso);
            if (validateDataDecesso) {
                return (
                    this.aggiungiToaster(["Messages.ERR_01_01_0E_0D"]))

            } else if (checkTodayDataDecesso) {
                return (
                    this.aggiungiToaster(["Messages.ERR_01_01_0E_0E"]))

            } else if (this.state.esito.esito === "23" && (this.state.esito.dataDecesso === "" || (Utils.isDateInValid(Utils.transformDateForBackend(this.state.esito.dataDecesso), "-")))) {

                let newMessaggio = Utils.replaceContentString(t("Messages.ERR_01_01_0B_0A"), "nome campo", t("Esito.dataDecesso"))
                return (
                    this.aggiungiToaster(newMessaggio))

            }
        }

        if (this.state.esito.dataEsame !== "") {
            let validateDataEsame = Utils.checkDateInterval(this.state.esito.dataEsame, "31/12/1899");
            let checkTodayDataEsame = Utils.checkDateLowerToday(this.state.esito.dataEsame);
            if (validateDataEsame) {
                return (
                    this.aggiungiToaster(["Messages.ERR_01_01_0E_0F"]))

            } else if (checkTodayDataEsame) {
                return (
                    this.aggiungiToaster(["Messages.ERR_01_01_0E_0Z"]))

            } else if ((Utils.isDateInValid(Utils.transformDateForBackend(this.state.esito.dataEsame), "-"))) {

                let newMessaggio = Utils.replaceContentString(t("Messages.ERR_01_01_0B_0A"), "nome campo", t("Esito.dataEsameAutoptico"))
                return (
                    this.aggiungiToaster(newMessaggio))

            } else if (this.state.esito.dataDecesso && Utils.checkDateIntervalMinore(this.state.esito.dataEsame, this.state.esito.dataDecesso)) {

                let newMessaggio = t("Messages.ERR_01_01_0E_0N")
                return (
                    this.aggiungiToaster(newMessaggio))
            } else if (!this.state.esito.esame || (this.state.esito.esame === "2" || this.state.esito.esame === "3")) {

                let newMessaggio = t("Messages.ERR_01_01_0E_0H")
                return (
                    this.aggiungiToaster(newMessaggio))
            } else if (this.state.esito.esito !== "23") {   //data esame autoptico valorizzato ma esito != da decesso
                let newMessaggio = t("Messages.ERR_01_01_0E_0I")
                return (
                    this.aggiungiToaster(newMessaggio))
            }


        }


        let ObjectForBackEnd = {}
        ObjectForBackEnd["esito"] = this.state.esito.esito;
        ObjectForBackEnd["esame"] = this.state.esito.esame;
        ObjectForBackEnd["dataDecesso"] = Utils.transformDateForBackend(this.state.esito.dataDecesso);
        ObjectForBackEnd["dataEsito"] = Utils.transformDateForBackend(this.state.esito.dataEsito);
        ObjectForBackEnd["dataEsame"] = Utils.transformDateForBackend(this.state.esito.dataEsame);


        let res = Utils.removeEmptyValueFromObject(ObjectForBackEnd);
        this.props.segnalazione["esito"] = res
        this.props.segnalazione["datiSpecifici"] = this.props.segnalazioneCopia.datiSpecifici

        if (clickSalvaOConferma === 1) {
            //salva - put
            this.callToPutSegnalazione();
        } else {
            //conferma
            this.callToConfermaEsito();
        }

    }

    onClickValidazione() {
        let jsonInsert = this.props.segnalazione

        jsonInsert.statoValidazione = OggettiUtili.statoValidazioneByLabel.Validata.codice
        SegnalazioniService.putModificaSegnalazione(jsonInsert, this.props.segnalazione.idSegnalazione, this.props.updateWizardState,
            this.props.segnalazione, this.props.showSpinner)

        let path = "/ricercaSegnalazioni"
        history.push({
            pathname: path,
            state: {
                currentState: states.HOME,
            }
        })
    }

    _back() {
        let path = "/ricercaSegnalazioni";
        history.push({pathname: path});
    }

    closePopup(){

        this.state.mostraPopUpIniziale=false

    }
    render() {
         
        const {t} = this.props;

        const firstSection = (
            <div>
                <h6>{t("Esito.esito")}</h6>
                <hr className={styles.hr}/>

                <div className="container">

                    <div className="row" style={{paddingTop: "10px"}}>
                        <div className="col-lg-4">
                            <p className={styles.testo}>{t("Esito.esito")}<span
                                className={styles.mandatoryColor}>*</span></p>
                        </div>
                        <div className="col-lg-4">
                            <Select
                                id={"esito"}
                                value={this.state.esito.esito === "148*" ? "148" : this.state.esito.esito}
                                onChange={this.handleChangeEsito}
                                functionMap={this.state.listaEsiti.map((oggetto) => {
                                    return (<option value={oggetto.codiceEsito} style={{backgroundColor:'white'}}>{oggetto.descrizioneEsito}</option>)
                                })}
                                addclass={!this.props.segnalazioneCopia.stepConfermati.esitoConfermato && this.props.malattiePremal.includes(this.props.segnalazioneCopia.malattia) && this.state.esito.esito === "148*"? 'select-yellow' : this.props.segnalazioneCopia.stepConfermati.esitoConfermato ?'select-white' : ''}
                                >

                            </Select>

                        </div>
                    </div>


                    <div className="row" style={{paddingTop: "10px"}}>
                        <div className="col-lg-4">
                            <p className={styles.testo}>{t("Esito.dataEsito")}
                                <span className={styles.mandatoryColor}> *</span>
                            </p>
                        </div>
                        <div className="col-lg-4">
                            <Calendar id={"dataEsito"}
                                      value={this.state.esito.dataEsito}
                                      field={"dataEsito"} onChange={this.riceviValore}
                                      errorMessage={
                                          (Utils.isDateInValid(Utils.transformDateForBackend(this.state.esito.dataEsito), "-") ?
                                              Utils.replaceContentString(t("Messages.ERR_01_01_0B_0A"), "<nome campo>", t("Esito.dataEsito")) : "")
                                      }
                                      error={Utils.isDateInValid(Utils.transformDateForBackend(this.state.esito.dataEsito), "-") &&
                                      this.state.esito.dataEsito !== ""}
                                      addclass={!this.props.segnalazioneCopia.stepConfermati.esitoConfermato && this.props.malattiePremal.includes(this.props.segnalazioneCopia.malattia) && this.state.esito.dataEsito === Utils.formatDateISO(this.props.segnalazioneCopia.timestampCompilazione)? 'select-yellow' : this.props.segnalazioneCopia.stepConfermati.esitoConfermato ? 'select-white' : ''}
                            />


                        </div>
                    </div>
                    <div className="row" style={{paddingTop: "10px"}}>
                        <div className="col-lg-4">
                            <p className={styles.testo}>{t("Esito.dataDecesso")}</p>
                        </div>
                        <div className="col-lg-4">
                            <Calendar id={"dataDecesso"}
                                      value={this.state.esito.dataDecesso}
                                      field={"dataDecesso"} onChange={this.riceviValore}
                                      errorMessage={
                                          (Utils.isDateInValid(Utils.transformDateForBackend(this.state.esito.dataDecesso), "-") ?
                                              Utils.replaceContentString(t("Messages.ERR_01_01_0B_0A"), "<nome campo>", t("Esito.dataDecesso")) : "")
                                      }
                                      error={Utils.isDateInValid(Utils.transformDateForBackend(this.state.esito.dataDecesso), "-") &&
                                      this.state.esito.dataDecesso !== ""}
                                      disabled={this.state.esito.esito !== "23" ? true : false}
                            />
                        </div>
                    </div>
                    <div className="row" style={{paddingTop: "10px"}}>
                        <div className="col-lg-4">
                            <p className={styles.testo}>{t("Esito.effettuazioneEsameAutoptico")}</p>
                            {this.state.esito.esito === "23" ? <span className={styles.mandatoryColor}>*</span> :
                                <span></span>}
                        </div>
                        <div className={"col-lg-4"}>
                            <Select
                                id={"esame"}
                                value={this.state.esito.esito === "23" ? this.state.esito.esame : ""}
                                onChange={this.handleChangeEsame}
                                functionMap={esameAutopticoMap.map((oggetto) => {
                                    return (<option value={oggetto.code}>{oggetto.displayName}</option>)
                                })}
                                disabled={this.state.esito.esito !== "23"}
                            >
                            </Select>


                        </div>
                    </div>
                    <div className="row" style={{paddingTop: "10px"}}>
                        <div className="col-lg-4">
                            <p className={styles.testo}>{t("Esito.dataEsameAutoptico")}
                                {this.state.esito.esame === "1" ? <span className={styles.mandatoryColor}>*</span> :
                                    <span></span>}</p>
                        </div>
                        <div className="col-lg-4">
                            <Calendar id={"dataEsame"}
                                      value={this.state.esito.dataEsame}
                                      field={"dataEsame"} onChange={this.riceviValore}
                                      errorMessage={
                                          (Utils.isDateInValid(Utils.transformDateForBackend(this.state.esito.dataEsame), "-") ?
                                              Utils.replaceContentString(t("Messages.ERR_01_01_0B_0A"), "<nome campo>", t("Esito.dataEsameAutoptico")) : "")
                                      }
                                      error={Utils.isDateInValid(Utils.transformDateForBackend(this.state.esito.dataEsame), "-") &&
                                      this.state.esito.dataEsame !== ""}
                                      disabled={this.state.esito.esito !== "23" || this.state.esito.esame !== "1"}
                            />
                        </div>
                    </div>
                </div>

            </div>
        );

        const secondSection = (
            <div>
                <div className={styles.margin}>
                    <h6>{t("Esito.migrazione")}</h6>
                    <hr className={styles.hr}/>
                </div>

                <div className={styles.margin}>
                    <div className="col-lg-8">
                        <Input
                            style={{height: "400px"}}
                            type={"textarea"}
                            id={"noteMigrazione"}
                            value={JSON.stringify(this.props.segnalazioneCopia.altreInformazioni, undefined, 2)}
                        >
                        </Input>
                    </div>
                </div>
            </div>
        )


        const buttons = (
            <ButtonRow
                onClickConfermaEProsegui={() => this.controlloDatiToaster("1")}
                isArchiviato={(this.props.segnalazione && this.props.segnalazione.migrazione) || SessioneUtente.getInstance().ruoliUtente === Ruoli.Operatore_Laboratorio.descrizione || (this.props.segnalazioneCopia && (this.props.segnalazioneCopia.statoSegnalazione === OggettiUtili.statoSegnalazioneByLabel.Archiviato.codice ||
                    this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice))}
                modalTextConferma={"Buttons.confermaModifica"}
                onClickSalva={() => this.controlloDatiToaster("2")}
                back={this._back}
                nextStep={true}
                differenzaGiorniValidazione={this.props.segnalazioneCopia.giorniValidita &&
                (this.props.segnalazioneCopia.giorniValidita - Utils.daysBetween(new Date(Utils.transformDateForBackend(this.props.segnalazioneCopia.dataSegnalazione)), new Date()) < 0 ? true : "")}
                validazioneMalattia={this.props.listaSezioni.length == 0 ? true : false}
                onClickValidazione={() => this.onClickValidazione()}
                confermaScheda={this.props.datiCompletiECorretti[3].completo}
                segnalazioneCopia={this.props.segnalazioneCopia}
            />
        );

        return (
            <div>
                {this.state.mostraPopUpIniziale && this.props.malattiePremal.includes(this.props.segnalazioneCopia.malattia)?
 
                    <Modale
                        classes="btnWhite"
                        id="modaleStep4e5"
                        title="Attenzione!"
                        modalText={this.props.segnalazioneCopia.malattia==="0578" || this.props.segnalazioneCopia.malattia==="7710"|| this.props.segnalazioneCopia.malattia==="6475" || this.props.segnalazioneCopia.malattia==="090" || this.props.segnalazioneCopia.malattia==="7712" || this.props.segnalazioneCopia.malattia==="011"?t("Messages.POPUPESITO2"):t("Messages.POPUPESITO1")}
                        typeModal="modalConsenso"
                        attivazioneImmediata={true}
                        confirmFun={this.closePopup}
                        soloModale={true} // Nasconde il bottone di attivazione
                        textButtonOk="Ho capito" // Nessun testo per il bottone OK
                        textButtonKo="" // Nessun testo per il bottone KO
                        buttonMail={true} // Nasconde i bottoni se usi questa logica nel tuo componente
                    />
                    : <div/> }
                <div
                    className={(this.props.segnalazione && this.props.segnalazione.migrazione) || SessioneUtente.getInstance().ruoliUtente === Ruoli.Operatore_Laboratorio.descrizione || (this.props.segnalazioneCopia.statoSegnalazione === OggettiUtili.statoSegnalazioneByLabel.Archiviato.codice ||
                        this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice) ? "visualizzazione" : ""}>
                    {ToasterSingleton.instance().renderToaster()}
                    <fieldset
                        disabled={(this.props.segnalazione && this.props.segnalazione.migrazione) || SessioneUtente.getInstance().ruoliUtente === Ruoli.Operatore_Laboratorio.descrizione || (this.props.segnalazioneCopia.statoSegnalazione === OggettiUtili.statoSegnalazioneByLabel.Archiviato.codice ||
                            this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice)}
                        style={{paddingTop: "1rem"}}>
                        {firstSection}
                    </fieldset>
                </div>

                {this.props.segnalazioneCopia && this.props.segnalazioneCopia.migrazione ? secondSection : null}

                <div style={{paddingTop: "2rem"}}>{buttons}</div>
            </div>

        );
    }
}


export default withTranslation('common')(Esito)
